interface Package {
  id: string;
  name: string;
  credits: number;
  price_cents: number;
  stripe_price_id?: string;
}

interface CreditPackagesProps {
  packages: Package[];
  onSelectPackage: (priceId: string, type: 'one_time') => void;
}

export default function CreditPackages({
  packages,
  onSelectPackage,
}: CreditPackagesProps) {
  const formatPrice = (cents: number) => {
    return `$${(cents / 100).toFixed(2)}`;
  };

  const getPricePerCredit = (priceCents: number, credits: number) => {
    return (priceCents / credits / 100).toFixed(3);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {packages.map((pkg) => (
        <div key={pkg.id} className="glass-card rounded-xl p-6">
          <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
            {pkg.name}
          </h4>
          <div className="mb-4">
            <p className="text-3xl font-bold text-gray-900 dark:text-white">
              {pkg.credits.toLocaleString()}
            </p>
            <p className="text-sm text-gray-600 dark:text-gray-400">credits</p>
          </div>
          <div className="mb-2">
            <p className="text-2xl font-bold text-primary-600 dark:text-primary-400">
              {formatPrice(pkg.price_cents)}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-500">
              ${getPricePerCredit(pkg.price_cents, pkg.credits)} per credit
            </p>
          </div>
          {pkg.stripe_price_id ? (
            <button
              onClick={() => onSelectPackage(pkg.stripe_price_id!, 'one_time')}
              className="w-full px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition"
            >
              Purchase
            </button>
          ) : (
            <button
              disabled
              className="w-full px-4 py-2 bg-gray-300 dark:bg-slate-700 text-gray-600 dark:text-gray-400 rounded-lg cursor-not-allowed"
            >
              Coming Soon
            </button>
          )}
        </div>
      ))}
    </div>
  );
}

